import React, { useEffect } from 'react';
import Price from './Price';
import GenericButton from './GenericButton';
import Image from './Image';
import constants from '../app/constants';
import { useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';

/**
 * The following params are set globally in mainSlice
 * and obtained with redux
 * @param price
 * @param discount
 * @param config
 */
const Summary = props => {
    const labels = useSelector(state => state.main.labels);
    const isInsuranceEnabled = useSelector(state => state.main.isInsuranceEnabled);
    const isInsuranceLoading = useSelector(state => state.main.isInsuranceLoading);
    const paymentInstallmentsType = useSelector(state => state.main.paymentInstallmentsType);
    const paymentInstallmentsQuantity = useSelector(
        state => state.main.paymentInstallmentsQuantity
    );
    const selectedPackage = useSelector(state => state.main.selectedPackage);
    const selectedWarranty = useSelector(state => state.main.selectedWarranty);
    const baseURLs = useSelector(state => state.main.baseURLs);
    const isGVP = useSelector(state => state.main.isGVP);

    useEffect(() => {
        if (typeof window.affirm !== 'undefined' && window.affirm.ui.refresh !== undefined) {
            window.affirm.ui.refresh();
        }
    }, [props.price, props.discount]);

    const handleAddToBag = () => {
        try {
            let products = utag_data.Products;

            tealium_data2track.push({
                id: 'AddToCart',
                Products: products,
            });
        } catch (error) {
            console.log(
                'Error during tealium_data2track push. Check if tealium_data2track exists in the window.'
            );
        }

        if (props.config.actionsModule) {
            if (!props.config.cartMode) {
                props.config.actionsModule.genericAddToCart(
                    props.config.data.frame,
                    selectedPackage,
                    selectedWarranty
                );
            } else {
                props.config.actionsModule.genericSaveEditFromCart(
                    props.config.data.frame,
                    selectedPackage,
                    selectedWarranty,
                    props.config.cartMode
                );
            }
        }
    };

    return (
        <div className="summary-container">
            {isGVP && !isInsuranceEnabled && (
                <div className="summary-gvp-title">{labels.price.gvp}</div>
            )}
            <Price
                label={labels.price.totalFrameLens}
                value={props.price}
                discount={props.discount}
                isSummaryPrice={true}
                isGVPPrice={isGVP && !props.isInsuranceEnabled}
                isInsuranceEnabled={isInsuranceEnabled}
                isInsuranceLoading={isInsuranceLoading}
            />
            <div className="link-container">
                {!isMobile && props.config.insuranceModule && !isInsuranceEnabled && (
                    <a
                        href="#"
                        className="lc-link insurance-label"
                        aria-label="Add or remove insurance benefits"
                        data-element-id="X_X_LensPanel_Review-UseInsurance"
                        onClick={props.handleInsuranceClick}
                        tabIndex="0"
                    >
                        {props.config && props.config.brand == 'opsm' && (
                            <Image
                                imageClass={
                                    'insurance-image' + (props.isInsuranceEnabled ? ' active' : ' ')
                                }
                                url={
                                    props.isInsuranceEnabled
                                        ? constants.baseURLs.genericImage
                                        : baseURLs.genericImage
                                }
                                fileName={props.isInsuranceEnabled ? 'global_green_tick' : 'fill-1'}
                                alt="insurance image"
                            />
                        )}
                        {labels.insurance.copy.inactive}
                    </a>
                )}
                {paymentInstallmentsType &&
                paymentInstallmentsType === constants.paymentInstallments.AFFIRM ? (
                    <span
                        id="affirm-product-rxc"
                        className="affirm-as-low-as product"
                        data-page-type="product"
                        data-amount={(props.price - props.discount) * 100}
                        data-learnmore-show="false"
                        data-affirm-type="text"
                    ></span>
                ) : null}
                {paymentInstallmentsType &&
                paymentInstallmentsType === constants.paymentInstallments.AFTERPAY &&
                paymentInstallmentsQuantity ? (
                    <div className="afterpay-container">
                        <div className="afterpay-inner-content" tabIndex="0">
                            <div className="afterpay-label">
                                {labels.paymentInstallments.afterPayLabel
                                    .replace('{0}', paymentInstallmentsQuantity)
                                    .replace('{1}', constants.currencyFormat.prefix)
                                    .replace(
                                        '{2}',
                                        (
                                            parseFloat(props.price - props.discount) /
                                            paymentInstallmentsQuantity
                                        ).toFixed(2)
                                    )}
                            </div>
                            <div className="afterpay-logo" />
                        </div>
                    </div>
                ) : null}
            </div>
            {props.config.insuranceModule && (
                <GenericButton
                    className={
                        'border-button insurance-button' + (isInsuranceEnabled ? ' active' : '')
                    }
                    handleClick={props.handleInsuranceClick}
                    dataAnalyticsAvailableCall="1"
                >
                    <Image
                        imageClass={'insurance-image' + (isInsuranceEnabled ? ' active' : '')}
                        url={
                            isInsuranceEnabled
                                ? constants.baseURLs.genericImage
                                : props.config.brand === 'opsm'
                                ? baseURLs.genericImage
                                : baseURLs.projectImage
                        }
                        fileName={
                            isInsuranceEnabled
                                ? 'global_green_tick'
                                : props.config.brand === 'opsm'
                                ? 'insurance-blue-shape'
                                : 'insurance-black-shape'
                        }
                        alt="insurance image"
                    />
                    {isInsuranceEnabled
                        ? labels.insurance.copy.active
                        : labels.insurance.copy.inactive}
                </GenericButton>
            )}
            <GenericButton
                className="filling-button add-to-bag"
                id="add-to-bag"
                handleClick={handleAddToBag}
                dataElementId="X_X_LensPanel_Review-AddCart"
                dataDescription={selectedWarranty != null ? selectedWarranty.id : ''}
            >
                {!props.config.cartMode ? labels.addToBag : labels.confirmChanges}
            </GenericButton>
        </div>
    );
};

export default Summary;
